import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import ddt from '@wix/da-ddt';
const logger = ddt.createLogger('flags');
export function isFlagEnabled(flags, condition) {
    if (!flags) {
        logger.error('No flags object passed');
        return false;
    }
    if (typeof condition === 'string') {
        return !!flags[condition];
    }
    return condition(flags);
}
export function isAnyFlagEnabled(flags, conditions) {
    if (!flags) {
        logger.error('No flags object passed');
        return false;
    }
    return conditions.some((flag)=>!!flags[flag]);
}
export function getEnabledFlagList(flags) {
    if (!flags) {
        logger.error('No flags object passed');
        return [];
    }
    return Object.keys(flags).filter((flag)=>!!flags[flag]);
}
/**
 * Converts the features array into features object
 */ export function flagsFromSession(features) {
    if (!features) {
        return {};
    }
    return features.reduce((o, feature)=>_object_spread_props(_object_spread({}, o), {
            [feature]: true
        }), {});
}
export function addCalculatedFlags(source) {
    if (!source) {
        logger.error('No flags object passed');
        return {};
    }
    return _object_spread({}, source);
}
